/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Placeflyersopen2Inputs */

const en_placeflyersopen2 = /** @type {(inputs: Placeflyersopen2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open the “${i?.name}” flyer`)
};

const de_placeflyersopen2 = /** @type {(inputs: Placeflyersopen2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Flyer „${i?.name}“ öffnen`)
};

/**
* | output |
* | --- |
* | "Open the “{name}” flyer" |
*
* @param {Placeflyersopen2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placeflyersopen2 = /** @type {((inputs: Placeflyersopen2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeflyersopen2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeflyersopen2(inputs)
	return de_placeflyersopen2(inputs)
});
export { placeflyersopen2 as "placeFlyersOpen" }